import { commonTypes } from '../common';

export const types = {
  REMOVE_NON_ONE_CLICK_STEP: 'UINEEDS/REMOVE_NON_ONE_CLICK_STEP',
};

export const initialState = {
  obd: {
    blockedByOBD: false,
    validLines: null,
  },
};

const UINeedsOBDReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_OBD_LINES: {
      const { lines } = action.payload;

      const newState = {
        ...state,
        obd: {
          ...state.obd,
          validLines: lines,
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case commonTypes.SET_BLOCKED_BY_OBD_STATUS: {
      const { status } = action.payload;

      const newState = {
        ...state,
        obd: {
          ...state.obd,
          blockedByOBD: status,
        },
      };
      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.REMOVE_NON_ONE_CLICK_STEP: {
      const newState = {
        ...state,
      };
      newState.flowInfo.flowJson.nonOneClickFlowInitialStep = null;
      newState.obd.validLines = [];
      newState.obd.cantChangeContacts = true;

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  removeNonOneClickStep: () => ({
    type: types.REMOVE_NON_ONE_CLICK_STEP,
  }),
};

export default UINeedsOBDReducer;
